import { render, staticRenderFns } from "./activity-collectCards-coupon.vue?vue&type=template&id=0ed035ae&scoped=true&"
import script from "./activity-collectCards-coupon.vue?vue&type=script&lang=js&"
export * from "./activity-collectCards-coupon.vue?vue&type=script&lang=js&"
import style0 from "./activity-collectCards-coupon.vue?vue&type=style&index=0&id=0ed035ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed035ae",
  null
  
)

export default component.exports